/**
 * Marketplace bookings — prices and RPC helpers (server validates price).
 */

import { supabase } from '../supabase';

export const BOOKING_PACKAGES = [
  { key: '2h', label: '2 Hours', price: 8000 },
  { key: 'half_day', label: 'Half Day', price: 14000, sub: '4 hours' },
  { key: 'full_day', label: 'Full Day', price: 24000, sub: '8 hours', popular: true },
  { key: 'weekly', label: 'Weekly', price: 95000, sub: '5 days' },
];

/**
 * @param {object} params
 * @param {boolean} params.authenticated
 */
export async function submitBooking(params) {
  const mode = params.mode === 'my-car' ? 'my_car' : 'driver_and_car';

  if (params.authenticated) {
    const { data, error } = await supabase.rpc('create_booking', {
      p_mode: mode,
      p_package: params.packageKey,
      p_start_date: params.startDate,
      p_start_time: params.startTime,
      p_pickup: params.pickup,
      p_area: params.area,
      p_notes: params.notes || null,
      p_emergency_contact: params.emergencyContact || null,
    });
    if (error) return { bookingId: null, error };
    return { bookingId: data, error: null };
  }

  const { data, error } = await supabase.rpc('create_guest_booking', {
    p_passenger_name: params.passengerName,
    p_passenger_phone: params.passengerPhone,
    p_emergency_contact: params.emergencyContact || null,
    p_mode: mode,
    p_package: params.packageKey,
    p_start_date: params.startDate,
    p_start_time: params.startTime,
    p_pickup: params.pickup,
    p_area: params.area,
    p_notes: params.notes || null,
  });
  if (error) return { bookingId: null, error };
  return { bookingId: data, error: null };
}
